import { Injectable } from '@angular/core';
import { DataTaskService } from '@app/core/services/data-task.service';

@Injectable({
    providedIn: 'root',
})
export class StockService {
    constructor(private datatask: DataTaskService) {}

    /**
     * @datatask 455
     * @datataskName sp_ws_p2_stocksearch_scan
     * @param params the barcode to scan.
     * @returns promise containing webpagename and parms to goto.
     */
    public async scan(params: ScanStockParams): Promise<ScanStockResponse> {
        return (await this.datatask.Post(455, params))[0];
    }

    /**
     * @datatask 4035
     */
    public async getStockStatusDrillDown(params: GetStockStatusDrillDownParams): Promise<StockStatusDrillDownGet> {
        return (await this.datatask.Post(4035, params))[0];
    }
}

export interface ScanStockParams {
    barcode: string;
    functionname: string;
}

export interface ScanStockResponse {
    webpagename: string;
    parms: string;
}

export interface GetStockStatusParams {
    stock_keyno: string | number;
}

export interface GetStockStatusDrillDownParams {
    stock_keyno: string | number;
    argtype: string;
}

export interface StockStatusDrillDownGet {
    page_heading: string;
    message: string;
    grid_datatask: string | number;
}
